module.exports = __webpack_public_path__ + "img/contributionplanner-howitworks2.417381a2.svg";